<template>
  <el-tabs
      tab-position="top">
    <el-tab-pane label="History">
      <accessory-history :registries="model.history" />
    </el-tab-pane>

    <el-tab-pane label="Requests">
      <accessory-own-requests :registries="model.requests" />
    </el-tab-pane>

    <el-tab-pane
        v-if="false"
        label="Related Requests">
      <accessory-related-requests :registries="model.related" />
    </el-tab-pane>

    <el-tab-pane
        v-if="false"
        label="RMA Reviews">
      <accessory-rma-reviews :registries="model.rmas" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import axios from "axios";
import history from "./history.json";
import AccessoryHistory from "./AccHistory";
import AccessoryOwnRequests from "./AccOwnRequests";
import AccessoryRmaReviews from "./AccRmaReviews";
import AccessoryRelatedRequests from "./AccRelatedRequests";

export default {
  name: "AccessoryHistoryTabPane",
  components: {
    AccessoryHistory,
    AccessoryOwnRequests,
    AccessoryRmaReviews,
    AccessoryRelatedRequests,
  },
  props: {
    deviceId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {
        history: [],
        requests: [],
        related: [],
        rmas: [],
      },
      request: {
        loading: false,
        failed: false,
      },
    };
  },
  computed: {
    endPoint() {
      return `v2/devices/${this.deviceId}/plc_history`;
      // return `/device_profiles/${this.deviceId}/history.json`;
    },
  },
  created() {
    if (this.deviceId) this.fetchAccessoryHistory();
  },
  methods: {
    fetchAccessoryHistory() {
      if (!this.deviceId) return;
      this.request.loading = true;
      this.request.failed = false;
      axios
        .get(this.endPoint)
        .then((response) => {
          this.model.history = response.data.history;
          this.model.requests = response.data.requests;
          this.model.related = response.data.related;
          this.model.rmas = response.data.rmas;
        })
        .catch((error) => {
          console.error(
            `Accessory history (${this.deviceId}) load failed.`,
            error
          );
          this.request.failed = true;
        })
        .finally(() => (this.request.loading = false));
    },
  },
};
</script>

<style scoped>
.accessories__expanded-history .el-table th > .cell {
  font-size: smaller;
}
</style>
